import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ArrowContainer } from 'react-tiny-popover';
import { cloneDeep, isEqual } from 'lodash-es';

import positionPopover from '../../../_shared/utils/positionPopover';
import FilterDisplayBox from '../../../_shared/components/FilterDisplayBox';
import PopoverWrapper from '../../../_shared/components/Popover';
import ListFilter from '../../../_shared/components/ListFilter';
import FilterService from '../../../services/FilterService';
import { FilterType } from '../../../_shared/constants/filters';

const propTypes = {
  distances: PropTypes.arrayOf(PropTypes.object).isRequired,
  buyerAddresses: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateFilter: PropTypes.func.isRequired
};

const DistanceFilter = ({ distances, buyerAddresses, updateFilter }) => {
  const [currentDistances, setCurrentDistances] = useState(distances);
  const [currentBuyerAddresses, setCurrentBuyerAddresses] = useState(
    buyerAddresses
  );

  useEffect(() => {
    setCurrentDistances(cloneDeep(distances));
    setCurrentBuyerAddresses(cloneDeep(buyerAddresses));
  }, [distances, buyerAddresses]);

  const updateDistance = useCallback(
    list => {
      if (isEqual(list, currentDistances)) {
        return;
      }
      setCurrentDistances(list);
      updateFilter(list, FilterType.Distance);
    },
    [currentDistances, updateFilter]
  );

  const updateBuyerAddress = useCallback(
    list => {
      if (isEqual(list, currentBuyerAddresses)) {
        return;
      }
      setCurrentBuyerAddresses(list);
      updateFilter(list, FilterType.BuyerAddress);
    },
    [currentBuyerAddresses, updateFilter]
  );

  const popoverChildFn = useCallback(title => {
    return setIsOpen => {
      return (
        <FilterDisplayBox
          openDropDown={() => setIsOpen(isOpen => !isOpen)}
          title={title}
          popOverOpen={setIsOpen}
          testId="distance-filter-dropdown"
        />
      );
    };
  }, []);

  const popoverDistance = useCallback(() => {
    return (openPopOver, { childRect, popoverRect }) => (
      <ArrowContainer
        position="right"
        childRect={childRect}
        popoverRect={popoverRect}
        arrowColor="white"
        arrowSize={10}
      >
        <ListFilter
          filterList={currentDistances}
          handleSelect={updateDistance}
          openPopOver={openPopOver}
        />
      </ArrowContainer>
    );
  }, [currentDistances, updateDistance]);

  const popoverBuyerAddress = useCallback(() => {
    return (openPopOver, { childRect, popoverRect }) => (
      <ArrowContainer
        position="right"
        childRect={childRect}
        popoverRect={popoverRect}
        arrowColor="white"
        arrowSize={10}
      >
        <ListFilter
          filterList={currentBuyerAddresses}
          handleSelect={updateBuyerAddress}
          openPopOver={openPopOver}
        />
      </ArrowContainer>
    );
  }, [currentBuyerAddresses, updateBuyerAddress]);

  return (
    <>
      <PopoverWrapper
        align="end"
        position={['right']}
        contentLocation={positionPopover()}
        renderContent={popoverDistance()}
        renderChild={popoverChildFn(
          FilterService.getActiveItem(currentDistances)
        )}
      />

      <PopoverWrapper
        align="end"
        position={['right']}
        contentLocation={positionPopover()}
        renderContent={popoverBuyerAddress()}
        renderChild={popoverChildFn(
          FilterService.getActiveItem(currentBuyerAddresses)
        )}
      />
    </>
  );
};

DistanceFilter.propTypes = propTypes;

export default DistanceFilter;
